import { useAddItemsToCart } from "@/hooks/useCart";
import { contentListIdsState } from "@/stores/cart";
import { IconButton } from "@material-ui/core";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import React from "react";
import { useRecoilValue } from "recoil";

interface IProps {
  verbose: boolean;
}

const CartButton: React.FC<IProps> = ({ verbose }) => {
  const { loading, handleAddToCart } = useAddItemsToCart();
  const ids = useRecoilValue(contentListIdsState);

  if (!verbose) return null;

  return (
    <IconButton
      color="primary"
      onClick={() => handleAddToCart(ids)}
      disabled={loading}
    >
      <AddShoppingCartIcon />
    </IconButton>
  );
};

export default CartButton;
